import LoadingComponent from '@/components/LoadingComponent/LoadingComponent'
import {
  RolePermissionGuard,
  RolePermissionProvider,
} from '@/components/RolePermission'
import { DEFAULT_ROUTE } from '@/constant/common'
import { USER_ROLE } from '@/constant/user'
import { useCompanySettingShowModules } from '@/hooks/useCompanySettingShowModules'
import { useAuth } from '@/providers/auth.provider'
import { Navigate } from 'react-router-dom'
import ProductRoute from './ProductRoute'
import { ProductFieldPermissionProvider } from './ProductFieldPermission'
import { PRODUCT_PERMISSION_MODULE } from './ProductPermission'

function ProductsLayoutContent() {
  const { user } = useAuth()
  const userRole = user?.subscription?.role_access?.role
  const { isLoading, shouldShowProductModule } = useCompanySettingShowModules(
    user?.id
  )

  if (isLoading) {
    return <LoadingComponent />
  }

  if (!shouldShowProductModule) {
    return (
      <Navigate
        replace
        to={
          userRole === USER_ROLE.INSPECTOR
            ? DEFAULT_ROUTE.QSF_INSPECTION
            : DEFAULT_ROUTE.PBF_ORDERS
        }
      />
    )
  }

  return (
    <RolePermissionGuard
      action="read"
      module={PRODUCT_PERMISSION_MODULE}
      fallback={
        <Navigate
          replace
          to={
            userRole === USER_ROLE.INSPECTOR
              ? DEFAULT_ROUTE.QSF_INSPECTION
              : DEFAULT_ROUTE.PBF_ORDERS
          }
        />
      }
    >
      <ProductRoute />
    </RolePermissionGuard>
  )
}

function ProductsLayout() {
  return (
    <RolePermissionProvider>
      <ProductFieldPermissionProvider>
        <ProductsLayoutContent />
      </ProductFieldPermissionProvider>
    </RolePermissionProvider>
  )
}

export default ProductsLayout
